import { Link } from 'react-router-dom'
import { type TableColumn } from 'react-data-table-component'
import FormattedDate from '../../components/FormattedDate'
import { Roles } from '../../components/Roles/Roles'
import { formatDate } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { isAdmin, isOwner } from '../../common/userUtils'
import { type User } from '../../models/User'
import { TeamStatusChip } from './TeamStatusChip'
import { type TeamRowActionHandlers, TeamRowActions } from './TeamRowActions'
import { type TeamRow } from './teamRows'
import { dateSortValue } from './utils'

const canOpenMemberPage = (row: TeamRow, authenticatedUser?: User | null) =>
  row.kind === 'member' && (row.id === authenticatedUser?.id || isAdmin(authenticatedUser) || isOwner(authenticatedUser))

export const buildTeamColumns = (authenticatedUser?: User | null): TableColumn<TeamRow>[] => [
  {
    name: 'Name',
    selector: (row) => row.name,
    sortable: true,
    grow: 2,
    cell: (row) =>
      canOpenMemberPage(row, authenticatedUser) ? (
        <Link className='zocks-text-primary' to={`/account/manage-team/users/${row.id}`}>
          {row.name}
        </Link>
      ) : (
        row.name
      ),
  },
  {
    name: 'Email',
    selector: (row) => row.email,
    sortable: true,
    grow: 2,
    width: '25%',
  },
  {
    name: 'Role',
    selector: (row) => JSON.stringify(row.roleIds),
    sortable: true,
    wrap: true,
    cell: (row) => <Roles userRoleIds={row.roleIds} />,
  },
  {
    name: 'Date added',
    selector: (row) => dateSortValue(row.createdAt),
    sortable: true,
    cell: (row) => <FormattedDate date={row.createdAt ? formatDate(row.createdAt) : ''} />,
    hide: 992,
    grow: 2,
  },
  {
    name: 'Status',
    selector: (row) => row.status,
    sortable: true,
    cell: (row) => (row.status ? <TeamStatusChip status={row.status} /> : null),
  },
]

export const buildTeamActionsColumn = (handlers: TeamRowActionHandlers): TableColumn<TeamRow> => ({
  ignoreRowClick: true,
  right: true,
  button: true,
  allowOverflow: true,
  width: '3rem',
  cell: (row) => <TeamRowActions row={row} {...handlers} />,
})
